module.exports = __webpack_public_path__ + "img/shoutao.fedfaf58.png";